import { fetchAllGames } from '@/lib/aggregation';
import type { Game } from '@/types/games';

type AllGamesApiResponse =
    | Game[]
    | {
          pageConfig?: {
              content?: Game[];
          };
          games?: Game[];
      }
    | null;

const parseAllGamesResponse = (response: AllGamesApiResponse): Game[] => {
    if (!response) {
        return [];
    }

    if (Array.isArray(response)) {
        return response;
    }

    if (Array.isArray(response.pageConfig?.content)) {
        return response.pageConfig.content;
    }

    if (Array.isArray(response.games)) {
        return response.games;
    }

    return [];
};

export const getAllGames = async (): Promise<Game[]> => {
    const response = (await fetchAllGames()) as AllGamesApiResponse;
    return parseAllGamesResponse(response);
};
